<!-- Dialog Header -->
<div class="flex items-center justify-between px-6 py-4 border-b">
    <h2 class="text-2xl font-semibold">{{ getDialogTitle() }}</h2>
    <button
        mat-icon-button
        (click)="close()"
        [tabIndex]="-1">
        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
</div>

<!-- Dialog Content -->
<div class="flex flex-col flex-auto px-6 py-4 overflow-hidden">

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex items-center justify-center py-12">
        <mat-spinner [diameter]="48"></mat-spinner>
    </div>

    <!-- Error State -->
    <div *ngIf="hasError" class="flex flex-col items-center justify-center py-12">
        <mat-icon 
            class="text-red-500 icon-size-16 mb-4"
            [svgIcon]="'heroicons_outline:exclamation-circle'">
        </mat-icon>
        <p class="text-lg font-medium text-red-600 mb-2">Error Loading History</p>
        <p class="text-secondary text-center max-w-md mb-4">{{ errorMessage }}</p>
        <button 
            mat-stroked-button 
            color="primary"
            (click)="loadAuditHistory()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
            <span class="ml-2">Retry</span>
        </button>
    </div>

    <!-- Empty State -->
    <div *ngIf="isDataEmpty()" class="flex flex-col items-center justify-center py-12">
        <mat-icon 
            class="text-gray-400 icon-size-16 mb-4"
            [svgIcon]="'heroicons_outline:document-text'">
        </mat-icon>
        <p class="text-lg font-medium text-secondary">No history found</p>
        <p class="text-sm text-secondary mt-2">There are no changes recorded for this {{ data.entityType.toLowerCase() }}.</p>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading && !hasError && !isDataEmpty()" class="flex flex-col flex-auto overflow-hidden">
        
        <!-- Table Container with Scroll -->
        <div class="overflow-auto flex-auto">
            <table 
                mat-table 
                [dataSource]="dataSource" 
                matSort
                class="w-full mat-elevation-z2">

                <!-- Field Name Column -->
                <ng-container matColumnDef="propertyName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-semibold">
                        Field Name
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="font-medium">{{ row.propertyName }}</span>
                    </td>
                </ng-container>

                <!-- Old Value Column -->
                <ng-container matColumnDef="oldValue">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-semibold">
                        Old Value
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="text-secondary">{{ formatValue(row.oldValue) }}</span>
                    </td>
                </ng-container>

                <!-- New Value Column -->
                <ng-container matColumnDef="newValue">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-semibold">
                        New Value
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <span class="text-primary">{{ formatValue(row.newValue) }}</span>
                    </td>
                </ng-container>

                <!-- Changed By Column -->
                <ng-container matColumnDef="changedByName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-semibold">
                        Changed By
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{ row.changedByName }}
                    </td>
                </ng-container>

                <!-- Changed On Column -->
                <ng-container matColumnDef="changedAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="font-semibold">
                        Changed On
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{ formatDate(row.changedAt) }}
                    </td>
                </ng-container>

                <!-- Header and Rows -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr 
                    mat-row 
                    *matRowDef="let row; columns: displayedColumns;"
                    class="hover:bg-gray-50 transition-colors">
                </tr>
            </table>
        </div>

        <!-- Paginator -->
        <mat-paginator
            class="border-t mt-auto"
            [pageSizeOptions]="PAGE_SIZE_OPTIONS"
            [pageSize]="DEFAULT_PAGE_SIZE"
            showFirstLastButtons>
        </mat-paginator>
    </div>
</div>

<!-- Dialog Actions -->
<div class="flex items-center justify-end px-6 py-4 border-t">
    <button
        mat-flat-button
        (click)="close()">
        Close
    </button>
</div>
